import { ExecutionStatus } from '@dynamika-shared/types/executions';

// NOTE: The DXAReadings slice initializes syncStatus optimistically to COMPLETED
// while lastSync stays '' until a real syncWorkstationStatus response lands.
// A non-empty lastSync is therefore the signal that the sync result is confirmed,
// so prefill must wait for both COMPLETED status and a populated lastSync.
export const canPrefill = (
  syncStatus: ExecutionStatus,
  lastSync: string
): boolean => syncStatus === ExecutionStatus.COMPLETED && !!lastSync;

export const countActiveSelections = (
  selected: Record<string, string>,
  presentRecordIds: Set<string>
): number =>
  Object.entries(selected).filter(
    ([recordId, labelId]) => !!labelId && presentRecordIds.has(recordId)
  ).length;
